export default __webpack_public_path__ + "static/media/bihorel6.25a0618a.jpg";